import { isAfter, isBefore, parseISO } from "date-fns";

/**
 * Returns true if the given day falls outside the submit limitation range.
 * Returns false when either bound is empty/falsy (no limitation configured).
 */
const isOutsideSubmitLimitation = (
  day: Date,
  submitLimitationFrom: string,
  submitLimitationTo: string
): boolean => {
  if (!submitLimitationFrom || !submitLimitationTo) return false;

  const limitFrom = parseISO(submitLimitationFrom);
  const limitTo = parseISO(submitLimitationTo);

  return isBefore(day, limitFrom) || isAfter(day, limitTo);
};

export default isOutsideSubmitLimitation;
